import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import overrideStyle from 'lib/overrideStyle';

import { getKBSearchResults } from 'app/modules';
import SearchResultsItemContainer from 'presentation/selfService/SearchResultsItem';

const DropDown = overrideStyle('div')`
    background: #ffffff;
    border: 1px solid #f9f9f9;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.11);
    overflow: scroll;
    padding: 10px;
    position: absolute;
    top: 138px;
    width: 329px;
    z-index: 1;
`;

class SearchResults extends React.Component {
  constructor(props) {
    super(props);

    SearchResults.propTypes = {
      currentFocusIndex: PropTypes.number.isRequired,
      searchResults: PropTypes.array,
      shouldShowDropDown: PropTypes.bool,
      value: PropTypes.string.isRequired,
    };
  }

  render() {
    if (this.props.searchResults.length > 0) {
      return (
        <DropDown>
          {this.props.searchResults.map((answer, currentIndex) => (
            <SearchResultsItemContainer
              answerId={answer.id}
              focused={currentIndex === this.props.currentFocusIndex}
              isSearchedAnswer={true}
              key={answer.id}
              name={answer.name.toString()}
              onBlur={this.props.onBlur}
            />
          ))}
        </DropDown>
      );
    } else {
      return null;
    }
  }
}

export const mapStateToProps = (state, props) => {
  return {
    ...props,
    searchResults: getKBSearchResults(state),
  };
};

const SearchResultsContainer = connect(mapStateToProps)(SearchResults);

export default SearchResultsContainer;
